import caES from './ca-ES'
import enGB from './en-GB'
import enUS from './en-US'
import esES from './es-ES'
import ruRU from './ru-RU'
import frFR from './fr-FR'
import esMX from './es-MX'
import es419 from './es-419'
import jaJP from './ja-JP'
import koKR from './ko-KR'
import ptPT from './pt-PT'
import thTH from './th-TH'
import trTR from './tr-TR'
import zhHK from './zh-HK'

const translations = Object.assign({},
  caES,
  esES,
  enUS,
  enGB,
  ruRU,
  frFR,
  esMX,
  es419,
  jaJP,
  koKR,
  ptPT,
  thTH,
  trTR,
  zhHK,
)

export default translations



// WEBPACK FOOTER //
// ./translations/index.js